import axios from "axios";
import { API_URL } from "../utils/constants";


// Función para obtener datos de la API
export const getData = async (endpoint) => {
    try {
        const response = await axios.get(`${API_URL}/${endpoint}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
};

// Función para enviar datos (POST) a la API
export const postData = async (endpoint, data) => {
    try {
        const response = await axios.post(`${API_URL}/${endpoint}`, data);
        return response.data;
    } catch (error) {
        console.error("Error posting data:", error.message);
        throw error;
    }
};

// Función para obtener detalles de catálogo
export const getQuestionsById = async (idForm) => {
    try {
        // Construir consulta
        const token = sessionStorage.getItem("token");
        let query = encodeURI(`SELECT R59302781,Realizada FROM Encuesta_Cita WHERE id = ${idForm}`);
        let Plantilla = await getData(`rest/api/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`);
        let isClient = false;
        if (Plantilla.length === 0) {
            query = encodeURI(`SELECT R59395341,Realizada FROM Encuesta_Cliente WHERE id = ${idForm}`);
            Plantilla = await getData(`rest/api/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`);
            isClient = true;
        }
        if (Plantilla.length > 0 && Plantilla[0][1] === 0 || !Plantilla[0][1]) {
            const queryQuestions = encodeURIComponent(`SELECT Orden,Tipo#value,Titulo,Opciones,Titulo_Plantilla,id FROM Preguntas_Plantilla WHERE R59302436 = ${Plantilla[0][0]} ORDER BY Orden ASC`);
            const dataQuestions = await getData(`rest/api/selectQuery?maxRows=99999&query=${queryQuestions}&sessionId=${token}&output=json`);
            return { dataQuestions, isClient }; // Ajusta según la estructura de la API
        } else {
            return { dataQuestions: null, isClient };
        }
    } catch (error) {
        console.error("Error fetching catalog details:", error.message);
        throw error;
    }
};

export const getQuestionsByIdStatic = async (idForm) => {
    try {
        // Construir consulta
        const token = sessionStorage.getItem("token");
        if (idForm) {
            const queryQuestions = encodeURIComponent(`SELECT Orden,Tipo#value,Titulo,Opciones,Titulo_Plantilla,id FROM Preguntas_Plantilla WHERE R59302436 = ${idForm} ORDER BY Orden ASC`);
            const dataQuestions = await getData(`rest/api/selectQuery?maxRows=99999&query=${queryQuestions}&sessionId=${token}&output=json`);
            return { dataQuestions, isClient: false }; // Ajusta según la estructura de la API
        } else {
            return { dataQuestions: null, isClient: false };
        }
    } catch (error) {
        console.error("Error fetching catalog details:", error.message);
        throw error;
    }
};

export const getClients = async () => {
    try {
        // Construir consulta
        const token = sessionStorage.getItem("token");
        const query = encodeURIComponent(`SELECT id,name FROM Cliente1`);
        const data = await getData(`rest/api/selectQuery?maxRows=99999&query=${query}&sessionId=${token}&output=json`);
        return data; // Ajusta según la estructura de la API

    } catch (error) {
        console.error("Error fetching catalog details:", error.message);
        throw error;
    }
};

export const getInfoCertificadoById = async (id) => {
    try {
        // Construir consulta
        const token = sessionStorage.getItem("token");
        const query = encodeURIComponent(`SELECT id,name,ResultadoPDF,Visualizado_,Fecha_Publicado FROM Consulta WHERE id = ${id}`);
        const data = await getData(`rest/api/selectQuery?maxRows=1&query=${query}&sessionId=${token}&output=json`);
        return data; // Ajusta según la estructura de la API

    } catch (error) {
        console.error("Error fetching catalog details:", error.message);
        throw error;
    }
};

export const updateQuestionsById = async (idForm, data, isClient) => {
    try {
        const token = sessionStorage.getItem("token");
        const response = await axios.post(`${API_URL}/updateRecord?output=json&objName=${isClient ? "Encuesta_Cliente" : "Encuesta_Cita"}&id=${idForm}&JSON_form=${JSON.stringify(data)}&sessionId=${token}`);
        return response;
    } catch (e) {
        console.log(e);
        return undefined;
    }
}

export const updateCertificadoById = async (id, Fecha_Hora_Visualizacion) => {
    try {
        const token = sessionStorage.getItem("token");
        const response = await axios.post(`${API_URL}/updateRecord?output=json&objName=Consulta&id=${id}&Visualizado_=true&Fecha_Hora_Visualizacion=${Fecha_Hora_Visualizacion}&sessionId=${token}`);
        return response;
    } catch (e) {
        console.log(e);
        return undefined;
    }
}

export const createQuestionsById = async (idPlantilla, data) => {
    try {
        const token = sessionStorage.getItem("token");
        const response = await axios.post(`${API_URL}/create2?output=json&objName=Encuesta_Cita&R59302781=${idPlantilla}&JSON_form=${JSON.stringify(data)}&sessionId=${token}`);
        return response;
    } catch (e) {
        console.log(e);
        return undefined;
    }
}

export const createQuestionsClientById = async (idPlantilla, data, Client) => {
    try {
        const token = sessionStorage.getItem("token");
        const response = await axios.post(`${API_URL}/create2?output=json&objName=Encuesta_Cliente&&R59395295=${Client?.value}&R59395341=${idPlantilla}&JSON_form=${JSON.stringify(data)}&sessionId=${token}`);
        return response;
    } catch (e) {
        console.log(e);
        return undefined;
    }
}

export const getToken = async (username, password) => {
    try {
        const response = await axios.post(`${API_URL}/login?loginName=${username}&password=${password}&output=json`);
        return response.data.sessionId;
    } catch (e) {
        console.log(e);
        return undefined;
    }
}